module.exports = __webpack_public_path__ + "static/media/Artboard – 9.c88745de.svg";